
export class SkillDocument {
    public userAttrDoc: any;
    public effetiveDTTM!: any;
    public expiryDTTM!: any;
    public effectiveDTTMText!: string;
    public expiryDTTMText!: string;
    public document!: string;
    public documentId;
}